(function () {
  'use strict';
  var NUM = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
  var docEl = document.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  docEl.classList.add('pz-js');

  /* desktop scale: the desktop layout is drawn at 1440px and scaled to the window.
     View experiment (27 Oct, preview only): a wider drawing canvas shows the page
     smaller ("zoomed out"), and full-width pictures can open out of an inset frame
     as they arrive. Visitors never see this: it needs ?pz_lab=1 once in this browser. */
  var LAB = { on: false, view: 1, frames: 'plates', type: 'new' };
  (function () {
    function st(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }
    var q = new URLSearchParams(location.search);
    if (q.get('pz_lab') === '1') st('pz_lab', '1');
    if (q.get('pz_lab') === '0') { st('pz_lab', null); st('pz_v2', null); st('pz_f2', null); st('pz_t2', null); }
    st('pz_view', null); st('pz_frames', null);   /* settings from the first round of the experiment no longer apply */
    if (q.get('pz_view')) st('pz_v2', q.get('pz_view'));
    if (q.get('pz_frames')) st('pz_f2', q.get('pz_frames'));
    LAB.on = st('pz_lab') === '1';
    if (!LAB.on) return;
    var v = parseFloat(st('pz_v2') || '1');
    LAB.view = v >= 0.6 && v <= 1 ? v : 1;
    LAB.frames = st('pz_f2') || 'plates';
    LAB.type = st('pz_t2') === 'old' ? 'old' : 'new';   /* compare the 27 Oct type sizes with the earlier, larger ones */
    if (LAB.type === 'old') document.documentElement.classList.add('pz-type-old');
    LAB.set = function (k, val) { st(k, String(val)); location.reload(); };
  })();
  var Z_CAP = 1.4, Z_SOFT = 0.35;
  function fit() {
    var w = docEl.clientWidth;
    if (w < 1024) return;
    /* the drawing scales with the window up to 1440px; beyond that it grows only gently
       (about 1.1x at 1920, 1.27x at 2560) and wider screens get a wider canvas instead of bigger type */
    var z = w <= 1440 ? w / 1440 : Math.min(Z_CAP, 1 + (w - 1440) / 1440 * Z_SOFT);
    if (LAB.view < 1) z = Math.max(z * LAB.view, Math.min(z, 0.7));
    docEl.style.setProperty('--pz-z', z.toFixed(5));
    docEl.style.setProperty('--pz-w', (w / z).toFixed(2) + 'px');
    /* sections drawn as a fixed composition (the homepage introduction) grow back on a wide canvas */
    var k = w / z / 1440;
    docEl.style.setProperty('--pz-grow', Math.min(1.25, Math.max(1, 1 + (k - 1) * 0.8)).toFixed(4));
  }
  fit();
  window.addEventListener('resize', fit);

  function layout() { return document.querySelector(window.innerWidth >= 1024 ? '.pz-d' : '.pz-m'); }

  /* ------------------------------------------------------------------
     Slide groups: <pz-s data-g data-i>, controls [data-pz-g][data-pz-d], counters <pz-c>
     ------------------------------------------------------------------ */
  /* step a slide group; groups inside the Carvers section cross-fade (fade out, then in) */
  function stepGroup(root, g, dir) {
    var items = root.querySelectorAll('pz-s[data-g="' + g + '"]');
    var n = 0, cur = 0, curEl = null;
    items.forEach(function (el) { var i = +el.getAttribute('data-i'); n = Math.max(n, i + 1); if (!el.hidden) { cur = i; curEl = el; } });
    if (!n) return;
    var nx = (cur + dir + n) % n, nxEl = null;
    items.forEach(function (el) { if (+el.getAttribute('data-i') === nx) nxEl = el; });
    var fade = !reduce && curEl && nxEl && !!curEl.closest('[data-masters]');
    function swap() {
      items.forEach(function (el) { el.hidden = +el.getAttribute('data-i') !== nx; el.classList.remove('is-out'); });
      if (fade) {
        nxEl.querySelectorAll('[data-pz-r]').forEach(function (x) { x.classList.add('is-in', 'is-done'); });
        nxEl.classList.add('is-fadein');
        setTimeout(function () { nxEl.classList.remove('is-fadein'); }, 950);
      }
      root.querySelectorAll('pz-c[data-g="' + g + '"]').forEach(function (c) {
        var f = c.getAttribute('data-f'), t = +c.getAttribute('data-n') || n;
        c.textContent = f === 'roman' ? NUM[nx] + ' / ' + NUM[t - 1] : f === 'pad' ? pad(nx + 1) + ' / ' + pad(t) : String(nx + 1);
      });
    }
    if (fade) { curEl.classList.add('is-out'); setTimeout(swap, 450); } else swap();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pz-g]');
    if (!b) return;
    e.preventDefault();
    var root = b.closest('.pz-d, .pz-m') || document;
    stepGroup(root, b.getAttribute('data-pz-g'), +b.getAttribute('data-pz-d'));
    var sec = b.closest('[data-masters]');
    if (sec && sec._pzAuto) sec._pzAuto.reset();
  });

  /* The Carvers of Inami: the pairs move on by themselves, every 6.5 s while the section is on screen.
     Pauses on hover, keyboard focus, touch, a hidden tab, and with reduced motion. */
  function setupCarvers() {
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-masters]').forEach(function (sec) {
      var root = sec.closest('.pz-d, .pz-m') || document;
      if (sec.querySelectorAll('pz-s[data-g="p"]').length < 2) return;
      var seen = false, hover = false, t = null, DUR = 6500;
      function live() { return seen && !hover && !lbOpen && !document.hidden && !sec.matches(':focus-within') && root.offsetParent !== null; }
      function arm() { clearTimeout(t); t = setTimeout(function () { if (live()) stepGroup(root, 'p', 1); arm(); }, DUR); }
      sec._pzAuto = { reset: arm };
      sec.querySelectorAll('pz-s[data-g="p"] img').forEach(function (i) { i.loading = 'eager'; });
      new IntersectionObserver(function (es) { es.forEach(function (en) { seen = en.isIntersecting; }); if (seen) arm(); }, { threshold: 0.35 }).observe(sec);
      sec.addEventListener('mouseenter', function () { hover = true; });
      sec.addEventListener('mouseleave', function () { hover = false; arm(); });
      sec.addEventListener('touchstart', function () { arm(); }, { passive: true });
    });
  }

  /* ------------------------------------------------------------------
     Phone menu
     ------------------------------------------------------------------ */
  var menu = document.querySelector('.pz-m .m-menu');
  var opener = null;
  function openMenu(btn) {
    if (!menu) return;
    opener = btn; menu.hidden = false;
    docEl.style.overflow = 'hidden';
    document.querySelectorAll('[data-pz-menu]').forEach(function (x) { x.setAttribute('aria-expanded', 'true'); });
    var c = menu.querySelector('[data-pz-close]'); if (c) c.focus();
  }
  function closeMenu() {
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    docEl.style.overflow = '';
    document.querySelectorAll('[data-pz-menu]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
    if (opener) opener.focus();
  }
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-pz-menu]');
    if (m) { e.preventDefault(); openMenu(m); return; }
    if (e.target.closest('[data-pz-close]')) { e.preventDefault(); closeMenu(); return; }
    var s = e.target.closest('[data-pz-sub]');
    if (s) {
      e.preventDefault();
      var li = s.parentNode, open = !li.classList.contains('is-open');
      li.classList.toggle('is-open', open); s.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var a = e.target.closest('a[href^="#"]');
    if (a && menu && !menu.hidden && menu.contains(a)) closeMenu();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lbOpen) closeMenu(); });
  window.addEventListener('resize', function () { if (window.innerWidth >= 1024) closeMenu(); });

  /* ------------------------------------------------------------------
     In-page anchors: the phone layout prefixes ids with m-
     ------------------------------------------------------------------ */
  function phone() { return window.innerWidth < 1024; }
  function target(hash) {
    if (!hash || hash.length < 2) return null;
    var id = decodeURIComponent(hash.slice(1));
    if (phone()) return document.getElementById(id.indexOf('m-') === 0 ? id : 'm-' + id) || document.getElementById(id);
    return document.getElementById(id.indexOf('m-') === 0 ? id.slice(2) : id) || document.getElementById(id);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented) return;
    var u = new URL(a.href, location.href);
    if (u.pathname !== location.pathname || !u.hash) return;
    var t = target(u.hash);
    if (t) { e.preventDefault(); t.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); history.replaceState(null, '', u.hash); }
  });
  function onLoadHash() { var t = target(location.hash); if (t) t.scrollIntoView({ block: 'start' }); }
  if (location.hash) { window.addEventListener('load', function () { setTimeout(onLoadHash, 60); }); }

  /* ------------------------------------------------------------------
     Videos: hero pause / play; muted loops play only while on screen
     ------------------------------------------------------------------ */
  var VL = document.documentElement.lang === 'ja'
    ? { pause: '映像を一時停止', play: '映像を再生', pauseA: '背景の映像を一時停止', playA: '背景の映像を再生' }
    : { pause: 'Pause video', play: 'Play video', pauseA: 'Pause background video', playA: 'Play background video' };
  /* Hero film (2 Nov). The page carries it twice (desktop and phone drawings, one hidden by CSS); only the copy on screen gets a
     source to load, so the two never stream at once (they did, and the film stalled). It keeps playing unless the visitor pauses
     it: restarted at its end, resumed after a pause nobody asked for (tab or window hidden, a browser's power saving) and when
     the opening comes back on screen; if the browser holds back autoplay (Safari in Low Power Mode) it starts at the first tap
     or key. Off screen it rests. No picture-in-picture or AirPlay offers on a background; the corner button follows the film. */
  var heroes = [];
  document.querySelectorAll('[data-pz-video]').forEach(function (b) {
    var v = b.parentNode.querySelector('.pz-hero-video video') || b.parentNode.querySelector('video');
    if (!v) return;
    v.disablePictureInPicture = true;
    v.setAttribute('disablepictureinpicture', '');
    v.setAttribute('disableremoteplayback', '');
    v.setAttribute('x-webkit-airplay', 'deny');
    v.removeAttribute('autoplay');
    var h = { b: b, v: v, sec: b.parentNode, user: false, seen: true, live: false };
    h.show = function () {
      if (v.paused) { b.textContent = VL.play; b.setAttribute('aria-label', VL.playA); }
      else { b.textContent = VL.pause; b.setAttribute('aria-label', VL.pauseA); }
    };
    v.addEventListener('play', h.show);
    v.addEventListener('pause', function () { h.show(); if (h.live && !h.user) setTimeout(function () { keepHero(h); }, 600); });
    v.addEventListener('ended', function () { if (h.live && !h.user) { try { v.currentTime = 0; } catch (err) {} keepHero(h); } });
    heroes.push(h);
  });
  var heroArmed = false;
  function keepHero(h) {
    if (!h.live || h.user || !h.seen || document.hidden || !h.v.paused) return;   /* plays with reduced motion too (Karim, 3 Nov); the corner button pauses it */
    var p;
    try { p = h.v.play(); } catch (err) { p = null; }
    if (p && p.catch) p.catch(function () {
      h.show();
      if (heroArmed) return;
      heroArmed = true;
      var go = function () { heroes.forEach(keepHero); };
      ['pointerdown', 'touchstart', 'touchend', 'click', 'keydown'].forEach(function (t) { document.addEventListener(t, go, { passive: true }); });
    });
  }
  function armHero(h) {
    var on = h.sec.getClientRects().length > 0;
    if (on === h.live) return;
    h.live = on;
    var v = h.v;
    if (on) {
      if (window.pzHeroLoad) window.pzHeroLoad(v);
      keepHero(h);
    } else {
      v.pause();
      if (v.getAttribute('data-pz-on')) { v.removeAttribute('data-pz-on'); v.removeAttribute('src'); v.preload = 'none'; v.load(); }
    }
  }
  heroes.forEach(armHero);
  heroes.forEach(function (h) { setTimeout(h.show, 1500); });
  var heroRz;
  window.addEventListener('resize', function () { clearTimeout(heroRz); heroRz = setTimeout(function () { heroes.forEach(armHero); }, 250); });
  document.addEventListener('visibilitychange', function () { heroes.forEach(keepHero); });
  window.addEventListener('pageshow', function () { heroes.forEach(keepHero); });
  if (heroes.length && 'IntersectionObserver' in window) {
    var hio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        heroes.forEach(function (h) {
          if (h.sec !== en.target) return;
          h.seen = en.isIntersecting;
          if (!h.live) return;
          if (h.seen) keepHero(h); else if (!h.v.paused) h.v.pause();
        });
      });
    }, { threshold: 0 });
    heroes.forEach(function (h) { hio.observe(h.sec); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pz-video]');
    if (!b) return;
    var h = heroes.filter(function (x) { return x.b === b; })[0];
    var v = h ? h.v : b.parentNode.querySelector('video');
    if (!v) return;
    if (v.paused) {
      if (h) h.user = false;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      b.textContent = VL.pause; b.setAttribute('aria-label', VL.pauseA);
    } else {
      if (h) h.user = true;
      v.pause();
      b.textContent = VL.play; b.setAttribute('aria-label', VL.playA);
    }
  });
  /* Home, Create with Inami: the chrysanthemum opens once as it comes into view (2 Nov). Without the script, or with reduced
     motion, it is simply there. */
  var blooms = document.querySelectorAll('.pz-bloom-wrap');
  if (blooms.length && 'IntersectionObserver' in window) {
    var bio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        bio.unobserve(en.target);
        var w = en.target, im = w.querySelector('img'), go = function () { w.classList.add('is-in'); };
        if (im && !im.complete) { im.addEventListener('load', go, { once: true }); im.addEventListener('error', go, { once: true }); } else go();
      });
    }, { threshold: 0.4 });
    blooms.forEach(function (b) { b.classList.add('is-wait'); bio.observe(b); });
  }


  /* 3 Nov: The Master Carvers (home): the pairs turn every 5 s by script, so a pair is never left half-faded. Pointing at the section,
     a focused link, the section off screen or a hidden tab only holds the next turn (the CSS animation paused mid-fade on hover and,
     on a phone, after a tap). Without the script the CSS animation runs and never pauses. */
  document.querySelectorAll('[data-masters]').forEach(function (sec) {
    var ps = sec.querySelectorAll('.mc-pair');
    if (ps.length < 2) return;
    var i = 0, hold = false, seen = true, HOLD = 5000, FADE = 1400;
    sec.classList.add('mc-js');
    ps.forEach(function (p, k) { p.classList.toggle('is-on', k === 0); if (k) p.setAttribute('aria-hidden', 'true'); else p.removeAttribute('aria-hidden'); });
    function turn() {
      if (!hold && seen && !document.hidden) {
        ps[i].classList.remove('is-on'); ps[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % ps.length;
        ps[i].classList.add('is-on'); ps[i].removeAttribute('aria-hidden');
      }
      setTimeout(turn, HOLD + FADE);
    }
    setTimeout(turn, HOLD + FADE);
    sec.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold = true; });
    sec.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold = false; });
    sec.addEventListener('focusin', function (e) { if (e.target.matches(':focus-visible')) hold = true; });
    sec.addEventListener('focusout', function () { hold = false; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[es.length - 1].isIntersecting; }).observe(sec);
  });

  var loops = document.querySelectorAll('video[data-pz-loop]');
  if (loops.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        v.pzSeen = en.isIntersecting;
        if (en.isIntersecting) loopPlay(v);
        else v.pause();
      });
    }, { threshold: 0.25 });
    loops.forEach(function (v) { vio.observe(v); });
  }
  /* 3 Nov: the looping films play for every visitor (reduced motion included, Karim); one the browser refuses to start (iOS Low Power
     Mode, an autoplay block) starts at the first touch, click or key anywhere on the page. */
  function loopPlay(v) {
    var p;
    try { p = v.play(); } catch (err) { p = null; }
    if (p && p.catch) p.catch(function () {
      if (loopArmed) return;
      loopArmed = true;
      var go = function () { loops.forEach(function (x) { if (x.pzSeen && x.paused) { var q = x.play(); if (q && q.catch) q.catch(function () {}); } }); };
      ['pointerdown', 'touchstart', 'touchend', 'click', 'keydown'].forEach(function (t) { document.addEventListener(t, go, { passive: true }); });
    });
  }
  var loopArmed = false;

  /* ------------------------------------------------------------------
     Header (after the Princeton University Art Museum bar): one row, logo left.
     At the top of the page it sits full height on the page. Scrolling down
     slides it away; scrolling back up brings it back as a slim paper bar.
     Within 10px of the top it returns to its full size. On the homepage the
     film's wordmark is the masthead, so at the very top the bar stays hidden.
     ------------------------------------------------------------------ */
  var heads = [], HD_BUF = 10, HD_SENS = 5;
  function setupHeader(scope) {
    if (!scope) return;
    var hd = null;
    scope.querySelectorAll('.site-hd').forEach(function (h) { if (!hd && !h.closest('.m-menu')) hd = h; });
    if (!hd) return;
    var wrap = hd.parentElement, anchor, hero = null;
    if (wrap && wrap.style.position === 'sticky') {
      wrap.style.position = 'relative';
      anchor = wrap;
      hero = scope.querySelector('section[aria-label="Opening"], section[aria-label="はじめに"]');
    } else {
      anchor = document.createElement('div');
      anchor.className = 'pz-hd-ph';
      hd.parentNode.insertBefore(anchor, hd);
    }
    var desk = scope.classList.contains('pz-d');
    var rec = { scope: scope, hd: hd, anchor: anchor, desk: desk, ph: anchor.className === 'pz-hd-ph', hero: hero, dir: 0, state: '' };
    hd.classList.add('pz-hd', desk ? 'pz-hd--d' : 'pz-hd--m');
    hd.style.transition = 'none';
    hd.classList.add('is-fixed');
    if (hero) hd.classList.add('pz-hd--home', 'is-away', 'is-top');
    void hd.offsetHeight;
    requestAnimationFrame(function () { requestAnimationFrame(function () { hd.style.transition = ''; }); });
    /* 5 Nov: while the bar is away, a quiet Menu stays: three hairlines just where the bar's own Menu sits (left on desktop, right on
       the phone; Karim: "more subtle, on the left like where it is normally ... just be 3 lines"); it opens the same menu */
    var src = desk ? hd.querySelector('.pz-fm-open') : hd.querySelector('[data-pz-menu]');
    if (src) {
      var fl = document.createElement('button'), lab = document.createElement('span'), ic = document.createElement('span');
      fl.type = 'button';
      fl.className = 'pz-fl ' + (desk ? 'pz-fl--d pz-fm-open' : 'pz-fl--m');
      ic.className = 'pz-fl__i'; ic.setAttribute('aria-hidden', 'true');
      lab.className = 'pz-fl__t'; lab.textContent = (src.textContent || '').trim() || 'Menu';
      fl.appendChild(ic); fl.appendChild(lab);
      fl.setAttribute('aria-label', lab.textContent);
      if (desk) { fl.setAttribute('aria-haspopup', 'dialog'); fl.setAttribute('aria-controls', 'pz-fm'); }
      else { fl.setAttribute('data-pz-menu', ''); fl.setAttribute('aria-controls', src.getAttribute('aria-controls') || 'm-pz-menu'); }
      fl.setAttribute('aria-expanded', 'false');
      hd.parentNode.insertBefore(fl, hd.nextSibling);
      rec.fl = fl;
    }
    heads.push(rec);
  }
  function measureHeads() {
    heads.forEach(function (r) {
      if (!r.ph) return;
      /* the spacer keeps the full-height bar's room at the top of the page */
      var c = r.hd.classList, had = c.contains('is-compact');
      r.hd.style.transition = 'none'; c.remove('is-compact');
      r.anchor.style.height = r.hd.offsetHeight + 'px';
      if (had) c.add('is-compact');
      void r.hd.offsetHeight; r.hd.style.transition = '';
    });
  }
  function headState(r, s) {
    if (s === r.state) return;
    r.state = s;
    var c = r.hd.classList;
    c.toggle('is-top', s === 'top');
    if (s === 'top') { c.remove('is-compact'); c.toggle('is-away', !!r.hero); }
    else if (s === 'away') c.add('is-away');
    else { c.add('is-compact'); c.remove('is-away'); }
    flSync(r);
  }
  /* the quiet Menu shows while the bar is away, except over the homepage's opening film, which carries its own Menu */
  function flSync(r) { if (r.fl) r.fl.classList.toggle('is-on', r.hd.classList.contains('is-away') && !overFilm(r)); }
  /* Desktop dropdowns (Commissions, About) open on click only, never on hover.
     Click again, click elsewhere, press Escape or scroll on to close. */
  var ddOpen = null, ddY = 0;
  function ddSet(li, open) {
    var sub = li.querySelector('.site-hd__sub'), a = li.querySelector(':scope > a');
    if (!sub) return;
    sub.classList.toggle('site-hd__sub--open', open);
    li.classList.toggle('is-open', open);
    if (a) a.setAttribute('aria-expanded', open ? 'true' : 'false');
    ddOpen = open ? li : (ddOpen === li ? null : ddOpen);
    if (open) ddY = window.pageYOffset || 0;
  }
  document.querySelectorAll('.pz-d .site-hd__has > a').forEach(function (a) {
    a.setAttribute('aria-expanded', 'false'); a.setAttribute('aria-haspopup', 'true');
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.pz-d .site-hd__has > a');
    if (a) {
      e.preventDefault();
      var li = a.parentElement, open = !li.classList.contains('is-open');
      if (ddOpen && ddOpen !== li) ddSet(ddOpen, false);
      ddSet(li, open);
      return;
    }
    if (ddOpen && !e.target.closest('.site-hd__sub')) ddSet(ddOpen, false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ddOpen) { var a = ddOpen.querySelector(':scope > a'); ddSet(ddOpen, false); if (a) a.focus(); }
  });

  function overFilm(r) {
    if (!r.hero) return false;
    var hb = r.hd.getBoundingClientRect().height || 80;
    return r.hero.getBoundingClientRect().bottom > hb;
  }
  var lastY = window.pageYOffset || 0;
  function updateHeads() {
    var y = window.pageYOffset || docEl.scrollTop || 0;
    var dy = y - lastY;
    heads.forEach(function (r) {
      if (!r.scope.offsetParent && getComputedStyle(r.scope).display === 'none') return;
      if (ddOpen && r.hd.contains(ddOpen)) {
        if (Math.abs(y - ddY) > 80) ddSet(ddOpen, false); else return;   /* menu in use */
      }
      /* homepage: the bar stays out of sight while any of the opening film is still under it (Karim, 27 + 30 Oct:
         the header must not pop up over the hero), whichever way the page is scrolling */
      if (overFilm(r)) { r.dir = 0; headState(r, y <= HD_BUF ? 'top' : 'away'); return; }
      if (y <= HD_BUF) { r.dir = 0; headState(r, 'top'); return; }
      if (Math.abs(dy) >= HD_SENS) {
        var d = dy > 0 ? 1 : -1;
        if (d !== r.dir) { r.dir = d; headState(r, d > 0 ? 'away' : 'shown'); }
      } else if (!r.state) {
        headState(r, 'shown');   /* opened part-way down the page */
      }
    });
    heads.forEach(flSync);
    lastY = y;
    /* 5 Nov (Karim: "when ur idle on a screen, doesnt show up. gives them a full screen feel"): a pause no longer brings the bar back,
       and once it has come back it slips away again after a few still seconds, unless it is in use */
    armHide();
  }
  var hdIdle = null, HD_HIDE = 2600;
  function armHide() { clearTimeout(hdIdle); hdIdle = setTimeout(hideIdle, HD_HIDE); }
  function hdInUse(r) {
    var kb = false;
    try { kb = !!r.hd.querySelector(':focus-visible'); } catch (err) {}
    var b = r.hd.getBoundingClientRect(), over = !!hdPtr && hdPtr.x >= b.left && hdPtr.x <= b.right && hdPtr.y >= b.top && hdPtr.y <= b.bottom;
    return kb || over || !!(ddOpen && r.hd.contains(ddOpen)) || docEl.classList.contains('pz-fm-lock') || !!(menu && !menu.hidden);
  }
  /* where the mouse is (a bar that slides in under a still pointer is not reliably :hover); touch leaves no pointer behind */
  var hdPtr = null;
  document.addEventListener('pointermove', function (e) { hdPtr = e.pointerType === 'mouse' ? { x: e.clientX, y: e.clientY } : null; }, { passive: true });
  document.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') hdPtr = null; }, { passive: true });
  docEl.addEventListener('mouseleave', function () { hdPtr = null; });
  function hideIdle() {
    var again = false;
    heads.forEach(function (r) {
      if (r.state !== 'shown') return;
      if (hdInUse(r)) { again = true; return; }
      r.dir = 0; headState(r, 'away');
    });
    if (again) armHide();
  }
  function revealHeads() {
    var y = window.pageYOffset || docEl.scrollTop || 0;
    if (y <= HD_BUF) return;
    heads.forEach(function (r) { if (r.state === 'away' && !overFilm(r)) { r.dir = 0; headState(r, 'shown'); } });
    armHide();
  }
  /* desktop: moving the pointer to the top edge of the window brings the bar back */
  document.addEventListener('mousemove', function (e) {
    if (e.clientY >= 72 || window.innerWidth < 1024) return;
    /* 5 Nov: not on the way to the quiet Menu, which would otherwise give way to the bar as it is reached */
    var near = false;
    heads.forEach(function (r) {
      if (!r.fl || !r.fl.classList.contains('is-on')) return;
      var b = r.fl.getBoundingClientRect();
      if (b.width && e.clientX >= b.left - 48 && e.clientX <= b.right + 48 && e.clientY <= b.bottom + 24) near = true;
    });
    if (!near) revealHeads();
  }, { passive: true });

  /* Homepage opening: the wordmark stays where it is while the film
     slides away beneath it; the film's lower edge carries it off. */
  function setupHero(scope) {
    if (!scope) return;
    var sec = scope.querySelector('section[aria-label="Opening"], section[aria-label="はじめに"]');
    if (!sec) return;
    var logo = sec.querySelector('.site-hd__logo');
    if (!logo) return;
    logo.classList.add('pz-hero-mark');
    logo.parentElement.classList.add('pz-hero-hold');
    sec.classList.add('pz-pin');
    pins.push({ sec: sec, hold: logo.parentElement, off: false });
  }
  var pins = [];
  function updatePins() {
    pins.forEach(function (p) {
      var off = p.sec.getBoundingClientRect().bottom <= 0;
      if (off !== p.off) { p.off = off; p.hold.style.visibility = off ? 'hidden' : ''; }
    });
  }

  var frame = null;
  function onScroll() {
    if (frame !== null) return;
    frame = requestAnimationFrame(function () { frame = null; updateHeads(); updatePins(); });
  }

  /* ------------------------------------------------------------------
     Reveal: titles settle up, photographs unveil from a soft inset,
     copy follows. Once each, as it enters; never fades back out.
     Elements carry data-pz-r (title | text | img | wide) from the build.
     ------------------------------------------------------------------ */
  function initReveal() {
    var all = document.querySelectorAll('[data-pz-r]');
    if (!docEl.classList.contains('pz-motion') || !('IntersectionObserver' in window)) {
      all.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      var batch = entries.filter(function (en) { return en.isIntersecting; }).map(function (en) { return en.target; });
      batch.sort(function (a, b) {
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
        return (Math.round(ra.top / 40) - Math.round(rb.top / 40)) || (ra.left - rb.left);
      });
      batch.forEach(function (el, i) {
        var st = Math.min(i * 0.09, 0.45);
        el.style.setProperty('--pz-stagger', st.toFixed(2) + 's');
        el.classList.add('is-in');
        io.unobserve(el);
        /* hand the element back its own transitions once the reveal is over */
        setTimeout(function () { el.classList.add('is-done'); }, 2700 + st * 1000);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
    all.forEach(function (el) {
      /* nested, excluded, or already scrolled past: shown as is */
      if (el.parentElement.closest('[data-pz-r]') || el.closest('.site-hd, .m-menu, footer, .ar-fade, section[aria-label="Opening"], section[aria-label="はじめに"], [data-pz-norev]')) {
        el.classList.add('is-in', 'is-static');
        return;
      }
      if (el.getBoundingClientRect().bottom < 0) { el.classList.add('is-in', 'is-static'); return; }
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Photo viewer: every photograph opens larger, at full resolution.
     ------------------------------------------------------------------ */
  var lb = null, lbImg = null, lbCap = null, lbList = [], lbIdx = 0, lbOpen = false, lbReturn = null;
  function viewable(img) {
    if (!img.getAttribute('data-pz-full')) return false;
    if (img.closest('a, button, .site-hd, .m-menu, footer, section[aria-label="Opening"], section[aria-label="はじめに"], [data-pz-nozoom], .pz-cyc')) return false;
    var r = img.getBoundingClientRect();
    return r.width >= 90 && r.height >= 60;
  }
  var BLOCK = /^(H[1-6]|P|DIV|LI|DT|DD|BLOCKQUOTE|PZ-S)$/;
  var NOCAP = /^(profile to come|coming soon|opening soon)$/i;
  function norm(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  function capParts(el, out) {
    var run = '';
    function flush() { var t = norm(run); if (t) out.push(t); run = ''; }
    Array.prototype.forEach.call(el.childNodes, function (n) {
      if (n.nodeType === 3) { run += n.textContent; return; }
      if (n.nodeType !== 1) return;
      if (BLOCK.test(n.tagName)) {
        flush();
        if (n.querySelector('h1,h2,h3,h4,h5,h6,p,div,li,dt,dd,blockquote')) capParts(n, out);
        else { var t = norm(n.textContent); if (t) out.push(t); }
      } else run += ' ' + n.textContent + ' ';
    });
    flush();
  }
  function capText(node) {
    var c = node.cloneNode(true);
    c.querySelectorAll('button, a, pz-c, svg, [hidden], [aria-hidden="true"], [aria-live]').forEach(function (x) { x.remove(); });
    var parts = [];
    capParts(c, parts);
    parts = parts.filter(function (t) { return !NOCAP.test(t); });
    if (parts.length < 2) return parts[0] || '';
    return parts[0] + ' \u2014 ' + parts.slice(1).join(' \u00b7 ');
  }
  function captionFor(img) {
    var fig = img.closest('figure');
    var slide = img.closest('pz-s[data-g]');
    if (fig && slide && fig.contains(slide)) {
      var own = fig.querySelector('figcaption pz-s[data-g="' + slide.getAttribute('data-g') + '"][data-i="' + slide.getAttribute('data-i') + '"]');
      var t0 = own ? capText(own) : '';
      return t0 || img.getAttribute('alt') || '';
    }
    var cap = fig && fig.querySelector('figcaption');
    var t = cap ? capText(cap) : '';
    return t || img.getAttribute('alt') || '';
  }
  function buildLb() {
    lb = document.createElement('div');
    lb.className = 'pz-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Photograph');
    lb.hidden = true;
    lb.innerHTML = '<div class="pz-lb__stage"><img class="pz-lb__img" alt=""></div>' +
      '<div class="pz-lb__bar"><p class="pz-lb__cap"></p></div>' +
      '<button type="button" class="pz-lb__btn pz-lb__close" aria-label="Close">Close</button>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('.pz-lb__img');
    lbCap = lb.querySelector('.pz-lb__cap');
    lb.querySelector('.pz-lb__close').addEventListener('click', closeLb);
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('pz-lb__stage')) closeLb(); });
    var sx = null, sy = null;
    lb.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; } }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
      if (dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.4) closeLb();
    }, { passive: true });
  }
  function showLb(i) {
    if (!lbList.length) return;
    lbIdx = (i + lbList.length) % lbList.length;
    var src = lbList[lbIdx];
    var full = src.getAttribute('data-pz-full');
    lb.classList.add('is-loading');
    lbImg.removeAttribute('srcset');
    lbImg.src = src.currentSrc || src.src;
    lbImg.alt = src.getAttribute('alt') || '';
    var hi = new Image();
    hi.decoding = 'async';
    hi.onload = function () { if (lbList[lbIdx] === src) { lbImg.src = full; lb.classList.remove('is-loading'); } };
    hi.onerror = function () { lb.classList.remove('is-loading'); };
    hi.src = full;
    var cap = captionFor(src);
    lbCap.textContent = cap;
    lbCap.hidden = !cap;
    lb.classList.add('is-single');
  }
  function openLb(img) {
    if (!lb) buildLb();
    lbList = [img];
    var i = 0;
    lbReturn = document.activeElement;
    lb.hidden = false;
    lbOpen = true;
    docEl.classList.add('pz-lb-on');
    document.querySelectorAll('[data-pz-rot]').forEach(function (b) { if (b._pzRot) b._pzRot.stop(); });
    showLb(i);
    requestAnimationFrame(function () { lb.classList.add('is-on'); });
    lb.querySelector('.pz-lb__close').focus({ preventScroll: true });
  }
  function closeLb() {
    if (!lbOpen) return;
    lbOpen = false;
    lb.classList.remove('is-on');
    docEl.classList.remove('pz-lb-on');
    document.querySelectorAll('[data-pz-rot]').forEach(function (b) { if (b._pzRot) b._pzRot.start(); });
    setTimeout(function () { if (!lbOpen) { lb.hidden = true; lbImg.removeAttribute('src'); } }, reduce ? 0 : 560);
    if (lbReturn && lbReturn.focus) lbReturn.focus({ preventScroll: true });
  }
  /* ------------------------------------------------------------------
     Look closer (4 Nov): as in the Works gallery, a photograph zooms in where it is, on the point pressed; move (or drag) to look
     around; press again, move off it, or Esc to step back. Pictures under 280 px wide still open in the viewer.
     ------------------------------------------------------------------ */
  var zm = null, ZW = 280;
  function inPlace(img) {
    if (img.closest('.pz-drv, .pz-aos, [data-masters]')) return false;   /* a still under a playing film; the turning portraits */
    var r = img.getBoundingClientRect(); return r.width >= ZW && r.height >= 120;
  }
  function visRect(img) {
    var r = img.getBoundingClientRect(), v = { l: r.left, t: r.top, r: r.right, b: r.bottom };
    for (var el = img.parentElement; el && el !== document.body && el !== docEl; el = el.parentElement) {
      var cs = getComputedStyle(el);
      if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible') {
        var p = el.getBoundingClientRect();
        v.l = Math.max(v.l, p.left); v.t = Math.max(v.t, p.top); v.r = Math.min(v.r, p.right); v.b = Math.min(v.b, p.bottom);
      }
    }
    return v;
  }
  function zSet(x, y) {
    if (!zm) return;
    zm.x = Math.min(1, Math.max(0, x)); zm.y = Math.min(1, Math.max(0, y));
    zm.im.style.transformOrigin = (zm.x * 100).toFixed(2) + '% ' + (zm.y * 100).toFixed(2) + '%';
  }
  function zAt(e) {
    var t = (e.touches && e.touches[0]) || e, r = zm.img.getBoundingClientRect();
    zSet((t.clientX - r.left) / r.width, (t.clientY - r.top) / r.height);
  }
  function zFactor(nw, nh, r, fit) {
    var shown = fit === 'cover' ? Math.max(r.width / nw, r.height / nh) * nw : fit === 'contain' ? Math.min(r.width / nw, r.height / nh) * nw : r.width;
    return Math.max(1.6, Math.min(2.6, nw / shown));
  }
  function rotators(on) { document.querySelectorAll('[data-pz-rot]').forEach(function (b) { if (b._pzRot) b._pzRot[on ? 'start' : 'stop'](); }); }
  function zoomIn(img, x, y) {
    zoomOut(true);
    var r = img.getBoundingClientRect(), v = visRect(img), cs = getComputedStyle(img);
    if (v.r - v.l < 40 || v.b - v.t < 40) return;
    var ov = document.createElement('div');
    ov.className = 'pz-zov';
    ov.setAttribute('aria-hidden', 'true');
    ov.style.cssText = 'left:' + (v.l + window.scrollX) + 'px;top:' + (v.t + window.scrollY) + 'px;width:' + (v.r - v.l) + 'px;height:' + (v.b - v.t) + 'px';
    var im = document.createElement('img');
    im.alt = ''; im.decoding = 'async'; im.draggable = false;
    im.src = img.currentSrc || img.src;
    im.style.cssText = 'left:' + (r.left - v.l) + 'px;top:' + (r.top - v.t) + 'px;width:' + r.width + 'px;height:' + r.height + 'px;object-fit:' + cs.objectFit +
      ';object-position:' + cs.objectPosition + ';opacity:' + cs.opacity + ';filter:' + cs.filter + ';mix-blend-mode:' + cs.mixBlendMode + ';border-radius:' + cs.borderRadius;
    ov.appendChild(im);
    document.body.appendChild(ov);
    var full = img.getAttribute('data-pz-full') || im.src;
    var mw = /[?&]width=(\d+)/.exec(full), guess = mw ? +mw[1] : (img.naturalWidth || r.width * 2);
    zm = { img: img, ov: ov, im: im, x: 0.5, y: 0.5, top: r.top + window.scrollY, left: r.left + window.scrollX,
           z: zFactor(guess, guess * (img.naturalHeight || r.height) / (img.naturalWidth || r.width), r, cs.objectFit) };
    zSet(x, y);
    img.style.visibility = 'hidden';
    rotators(false);
    var hi = new Image();
    hi.decoding = 'async';
    hi.onload = function () {
      if (!zm || zm.im !== im) return;
      im.src = full;
      var z = zFactor(hi.naturalWidth, hi.naturalHeight, r, cs.objectFit);
      if (Math.abs(z - zm.z) > 0.05) { zm.z = z; if (ov.classList.contains('is-on')) im.style.transform = 'scale(' + z.toFixed(3) + ')'; }
    };
    hi.src = full;
    void im.offsetWidth;
    ov.classList.add('is-on');
    im.style.transform = 'scale(' + zm.z.toFixed(3) + ')';
  }
  function zoomOut(now) {
    if (!zm) return;
    var z = zm; zm = null;
    rotators(true);
    function done() { z.ov.remove(); z.img.style.visibility = ''; }
    if (now || reduce) { done(); return; }
    z.ov.classList.remove('is-on');
    z.im.style.transform = 'scale(1)';
    setTimeout(done, 520);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.pz-zov')) { e.preventDefault(); zoomOut(); return; }
    if (zm) zoomOut(true);   /* a tap anywhere else (a tab, a link) steps back first */
    var img = e.target.closest('img[data-pz-full]');
    if (!img || e.defaultPrevented || !viewable(img)) return;
    e.preventDefault();
    if (inPlace(img)) {
      var r = img.getBoundingClientRect();
      zoomIn(img, (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
    } else openLb(img);
  });
  document.addEventListener('mousemove', function (e) { if (zm && e.target.closest && e.target.closest('.pz-zov')) zAt(e); });
  document.addEventListener('mouseout', function (e) {
    if (!zm || !e.target.closest || !e.target.closest('.pz-zov')) return;
    if (!e.relatedTarget || !zm.ov.contains(e.relatedTarget)) zoomOut();
  });
  document.addEventListener('touchmove', function (e) {
    if (!zm || !e.target.closest || !e.target.closest('.pz-zov')) return;
    e.preventDefault(); zAt(e);
  }, { passive: false });
  document.addEventListener('keydown', function (e) {
    if (lbOpen) return;
    var t = e.target;
    if (zm && e.key === 'Escape') { e.preventDefault(); var back = zm.img; zoomOut(); back.focus({ preventScroll: true }); return; }
    if (zm && /^Arrow/.test(e.key)) {
      e.preventDefault();
      var d = 0.12;
      zSet(zm.x + (e.key === 'ArrowRight' ? d : e.key === 'ArrowLeft' ? -d : 0), zm.y + (e.key === 'ArrowDown' ? d : e.key === 'ArrowUp' ? -d : 0));
      return;
    }
    if ((e.key === 'Enter' || e.key === ' ') && t && t.tagName === 'IMG' && t.classList.contains('pz-zoomable')) {
      e.preventDefault();
      if (zm && zm.img === t) zoomOut();
      else if (inPlace(t)) zoomIn(t, 0.5, 0.5);
      else openLb(t);
    }
  });
  function zCheck() {
    if (!zm) return;
    var r = zm.img.getBoundingClientRect();
    if (Math.abs(r.top + window.scrollY - zm.top) > 1 || Math.abs(r.left + window.scrollX - zm.left) > 1 || r.bottom < 0 || r.top > window.innerHeight) zoomOut(true);
  }
  window.addEventListener('scroll', zCheck, { passive: true });
  document.addEventListener('scroll', function (e) { if (e.target !== document) zCheck(); }, true);
  window.addEventListener('resize', function () { zoomOut(true); });
  document.addEventListener('keydown', function (e) {
    if (!lbOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); closeLb(); }
    else if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) { return b.offsetParent; });
      if (!f.length) return;
      var a = f.indexOf(document.activeElement);
      if (e.shiftKey && a <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && a === f.length - 1) { e.preventDefault(); f[0].focus(); }
    }
  });
  function markZoomable() {
    var ja = (docEl.getAttribute('lang') || '').indexOf('ja') === 0;
    document.querySelectorAll('img[data-pz-full]').forEach(function (img) {
      if (!viewable(img) || img.classList.contains('pz-zoomable')) return;
      img.classList.add('pz-zoomable');
      img.tabIndex = 0;
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', (img.getAttribute('alt') || '') + (ja ? '（拡大して見る）' : ' (look closer)'));
    });
  }


  /* ------------------------------------------------------------------
     Works rotation: a slow cross-fade between a few works.
     Pauses off-screen, on hover/focus and in a hidden tab; static with reduced motion.
     ------------------------------------------------------------------ */
  function setupRotators() {
    document.querySelectorAll('[data-pz-rot]').forEach(function (box) {
      var s = box.querySelectorAll('.pz-rot__s');
      if (s.length < 2) return;   /* 3 Nov: turns with reduced motion too */
      var i = 0, timer = null, vis = false, hold = false, busy = false, DUR = (+box.getAttribute('data-pz-rot')) || 5200;
      function warm(n) { var im = s[n].querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; }
      function go() {
        if (busy) return;
        var n = (i + 1) % s.length, im = s[n].querySelector('img');
        function swap() { var o = s[i]; o.classList.add('is-prev'); o.classList.remove('is-on'); s[n].classList.add('is-on'); i = n; setTimeout(function () { o.classList.remove('is-prev'); busy = false; warm((i + 1) % s.length); }, 1700); }
        busy = true;
        if (im && !im.complete) { warm(n); im.addEventListener('load', swap, { once: true }); im.addEventListener('error', function () { busy = false; }, { once: true }); }
        else swap();
      }
      function start() { if (!timer && vis && !hold && !document.hidden && !lbOpen) timer = setInterval(go, DUR); }
      function stop() { clearInterval(timer); timer = null; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          vis = es[es.length - 1].isIntersecting;
          if (vis) { warm(1); start(); } else stop();
        }, { threshold: 0.2 }).observe(box);
      }
      box.addEventListener('mouseenter', function () { hold = true; stop(); });
      box.addEventListener('mouseleave', function () { hold = false; start(); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      box._pzRot = { start: start, stop: stop };
    });
  }

  /* View experiment: the switcher (preview only) and the opening-out frames */
  function setupLab() {
    if (!LAB.on) return;
    var p = document.createElement('div');
    p.className = 'pz-lab';
    p.setAttribute('role', 'group'); p.setAttribute('aria-label', 'View experiment');
    var views = [[1, 'Default'], [0.9, '90'], [0.8, '80']];
    var h = '<span class="pz-lab__l">View</span>';
    views.forEach(function (o) { h += '<button type="button" data-v="' + o[0] + '"' + (Math.abs(LAB.view - o[0]) < 0.001 ? ' aria-pressed="true"' : '') + '>' + o[1] + (o[0] < 1 ? '%' : '') + '</button>'; });
    h += '<span class="pz-lab__l">Frames</span>';
    [['0', 'Off'], ['plates', 'Plates'], ['1', 'All']].forEach(function (o) { h += '<button type="button" data-f="' + o[0] + '"' + (LAB.frames === o[0] ? ' aria-pressed="true"' : '') + '>' + o[1] + '</button>'; });
    h += '<span class="pz-lab__l">Type</span>';
    [['new', 'Smaller'], ['old', 'Larger']].forEach(function (o) { h += '<button type="button" data-t2="' + o[0] + '"' + (LAB.type === o[0] ? ' aria-pressed="true"' : '') + '>' + o[1] + '</button>'; });
    p.innerHTML = h;
    p.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-v')) LAB.set('pz_v2', b.getAttribute('data-v'));
      else if (b.hasAttribute('data-t2')) LAB.set('pz_t2', b.getAttribute('data-t2'));
      else LAB.set('pz_f2', b.getAttribute('data-f'));
    });
    document.body.appendChild(p);
  }

  /* Frames: the big full-width plates start a little inset and open out to the edges
     as they come up the screen (the homepage plate, the Commissions and Architecture closing bands). */
  function setupFrames() {
    var mode = LAB.on ? LAB.frames : 'plates';
    if (mode === '0') return;
    var seen = [], frames = [], INSET = mode === '1' ? 7 : 5;
    function add(el) { if (el && seen.indexOf(el) < 0) { seen.push(el); frames.push(el); el.classList.add('pz-frame-out'); } }
    if (mode === '1') {
      document.querySelectorAll('img[data-pz-r="wide"]').forEach(function (img) {
        if (img.closest('footer, .site-hd, section[aria-label="Opening"], section[aria-label="はじめに"]')) return;
        add(img.closest('.pz-rot') ? img.closest('figure') || img.closest('.pz-rot') : (img.closest('figure') || img.parentElement));
      });
    } else {
      document.querySelectorAll('[data-pz-rot="7000"]').forEach(function (r) { add(r.closest('figure') || r); });
      document.querySelectorAll('.cp-close').forEach(add);
    }
    if (!frames.length) return;
    function upd() {
      var vh = window.innerHeight;
      frames.forEach(function (el) {
        var top = el.getBoundingClientRect().top;
        var p = Math.max(0, Math.min(1, (vh - top) / (vh * 0.75)));
        el.style.setProperty('--pz-in', ((1 - p) * INSET).toFixed(2) + '%');
      });
    }
    var tk = null;
    window.addEventListener('scroll', function () { if (tk === null) tk = requestAnimationFrame(function () { tk = null; upd(); }); }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* Dropdown panels: the photograph and its line follow the link under the pointer or focus. */
  function setupMM() {
    document.querySelectorAll('.pz-mm').forEach(function (mm) {
      function act(i) {
        mm.querySelectorAll('[data-mm]').forEach(function (e) { e.classList.toggle('is-on', e.getAttribute('data-mm') === i); });
      }
      mm.querySelectorAll('.pz-mm__a').forEach(function (a) {
        var i = a.getAttribute('data-mm');
        a.addEventListener('pointerenter', function () { act(i); });
        a.addEventListener('focus', function () { act(i); });
      });
      var li = mm.closest('.site-hd__has');
      if (li) li.addEventListener('pointerleave', function () { if (!li.classList.contains('is-open')) act('0'); });
    });
  }

  /* Full-page menu (desktop): Menu opens it, Close or Escape shuts it. Pointing at or focusing a section
     shows its pages and its photograph. Focus stays inside while it is open and returns to Menu afterwards. */
  function setupFM() {
    var fm = document.getElementById('pz-fm');
    if (!fm) return;
    var openers = document.querySelectorAll('.pz-fm-open'), closer = fm.querySelector('.pz-fm__close'), back = null, tm = null;
    function act(li) {
      var k = li.getAttribute('data-fm');
      fm.querySelectorAll('.pz-fm__item').forEach(function (x) { x.classList.toggle('is-on', x === li); });
      fm.querySelectorAll('.pz-fm__img').forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-fm') === k); });
    }
    function open() {
      back = document.activeElement; clearTimeout(tm);
      fm.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { fm.classList.add('is-open'); }); });
      docEl.classList.add('pz-fm-lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { closer.focus({ preventScroll: true }); }, 60);
    }
    function close() {
      fm.classList.remove('is-open');
      docEl.classList.remove('pz-fm-lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      tm = setTimeout(function () { fm.hidden = true; }, reduce ? 0 : 420);
      if (back && back.focus) back.focus({ preventScroll: true });
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    closer.addEventListener('click', close);
    fm.querySelectorAll('.pz-fm__item').forEach(function (li) {
      li.addEventListener('pointerenter', function () { act(li); });
      li.addEventListener('focusin', function () { act(li); });
    });
    fm.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = [].filter.call(fm.querySelectorAll('a[href],button'), function (x) { return x.offsetParent !== null && getComputedStyle(x).visibility !== 'hidden'; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    fm.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var u = new URL(a.href, location.href);
      if (u.pathname === location.pathname && u.hash) { close(); }   /* same-page anchors (Newsletter, Works) */
    });
  }

  /* ------------------------------------------------------------------
     Search (5 Nov, Karim: "make it functional and connected to the website"): the site's own index, searched as you type.
     The search icon and every link to /search open it over the page ("/" opens it too); the /search page carries it in the page.
     pz-search.js and the index load the first time they are wanted (or when a search link is pointed at).
     ------------------------------------------------------------------ */
  var PZS_V = '5168adf444';
  window.PZS_CFG = { base: (function () { var s = document.querySelector('script[src*="/assets/pz.js"]'); return s ? s.src.replace(/pz\.js(\?.*)?$/, '') : '/'; })(), v: PZS_V };
  var pzsP = null;
  function pzsReady() {
    if (window.PZSearch) return Promise.resolve(window.PZSearch);
    if (pzsP) return pzsP;
    pzsP = new Promise(function (ok, no) {
      var s = document.createElement('script');
      s.src = window.PZS_CFG.base + 'pz-search.js?v=' + PZS_V; s.async = true;
      s.onload = function () { if (window.PZSearch) ok(window.PZSearch); else no(); };
      s.onerror = function () { pzsP = null; no(); };
      document.head.appendChild(s);
    });
    return pzsP;
  }
  function pzsIs(u) { return u.origin === location.origin && /^\/(ja\/)?search\/?$/.test(u.pathname); }
  function pzsMenusAway() {
    if (docEl.classList.contains('pz-fm-lock')) { var c = document.querySelector('#pz-fm .pz-fm__close'); if (c) c.click(); }
    closeMenu();
  }
  function setupSearch() {
    var here = pzsIs(new URL(location.href));
    var mounts = document.querySelectorAll('[data-pzs-page]');
    if (here && mounts.length) {
      var q = new URL(location.href).searchParams.get('q') || '';
      pzsReady().then(function (S) { mounts.forEach(function (m) { S.mount(m, q); }); });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.closest('.pzs')) return;
      var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (!pzsIs(u)) return;
      e.preventDefault();
      pzsMenusAway();
      if (here && mounts.length) {
        var vis = [].filter.call(document.querySelectorAll('.pzs--page .pzs__q'), function (i) { return i.offsetParent !== null; })[0];
        if (vis) { vis.focus(); vis.select(); return; }
      }
      pzsReady().then(function (S) { S.open(u.searchParams.get('q') || ''); }, function () { location.href = u.href; });
    });
    var warm = function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/search"]');
      if (a) { document.removeEventListener('pointerover', warm); document.removeEventListener('focusin', warm); pzsReady().then(function (S) { S.load(); }); }
    };
    document.addEventListener('pointerover', warm, { passive: true });
    document.addEventListener('focusin', warm);
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey || lbOpen) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      if (document.querySelector('.pzs')) return;
      e.preventDefault();
      pzsMenusAway();
      pzsReady().then(function (S) { S.open(''); });
    });
    /* /pages/works#TS008 opens that work (a search result, or a link from anywhere) */
    function workFromHash() {
      var m = /^#([A-Z]{2}\d{3}|BRIDGE)$/.exec(location.hash);
      if (!m) return;
      var o = null;
      document.querySelectorAll('.pz-d, .pz-m').forEach(function (r) { if (!o && getComputedStyle(r).display !== 'none') o = r.querySelector('[data-wk-open="' + m[1] + '"]'); });
      if (!o) return;
      o.scrollIntoView({ block: 'center', behavior: 'auto' });
      setTimeout(function () { o.click(); }, 260);
    }
    if (location.hash) window.addEventListener('load', function () { setTimeout(workFromHash, 140); });
    window.addEventListener('hashchange', workFromHash);
  }

  /* ------------------------------------------------------------------ */
  function init() {
    setupHeader(document.querySelector('.pz-d'));
    setupHeader(document.querySelector('.pz-m'));
    setupHero(document.querySelector('.pz-d'));
    setupHero(document.querySelector('.pz-m'));
    measureHeads();
    updateHeads();
    updatePins();
    initReveal();
    markZoomable();
    setupRotators();
    setupCarvers();
    setupLab();
    setupFrames();
    setupMM();
    setupFM();
    setupSearch();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measureHeads(); onScroll(); markZoomable(); });
    window.addEventListener('load', function () { measureHeads(); onScroll(); markZoomable(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measureHeads(); onScroll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
